import firebase from 'firebase';
import { v4 as uuidv4 } from 'uuid';

export default {
  name: 'croppie-mixin',

  data() {
    return {
      showCroppie: false,
      galleryImg: null,
      imageSrc: null,
      chatImgToUpload: null,
    };
  },
  methods: {
    croppie(e) {
      this.showCroppie = true;
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;

      this.chatImgToUpload = files[0].name;

      const reader = new FileReader();
      reader.onload = (event) => {
        this.imageSrc = event.target.result;
      };

      reader.readAsDataURL(files[0]);
    },

    async cropChatPhoto() {
      const { canvas } = this.$refs.croppieDialog.$refs.croppieRef.getResult();

      if (canvas) {
        const x = this.getResizedCanvas(canvas, 300, 300);
        const timestamp = Date.now();

        return new Promise((resolve, reject) => {
          x.toBlob(async (blob) => {
            this.$store.state.loading = true;
            const imgName = `${timestamp}-${this.chatImgToUpload}.png`;

            const storageRef = await firebase
              .storage()
              .ref(`images/${this.$store.state.user_data.id}/chat/${imgName}`);

            await storageRef
              .put(blob)
              .then((e) => {
                this.sucess_upload = e;
                return e.ref.getDownloadURL();
              })
              .then((downloadURL) => {
                this.$store.state.loading = false;
                this.$store.state.chatImageToSave = downloadURL;
                this.showCroppie = false;
                resolve(true);
              })
              .catch((e) => {
                this.chatImgToUpload = null;
                this.showCroppie = false;
                this.$store.state.loading = false;
                return Promise.reject();
              });
          }, 'image/png');
        });
      }
      return Promise.resolve(false);
    },

    async cropGalleryOrProfilPhoto(gallery = false) {
      const { canvas } = this.$refs.croppieDialog.$refs.croppieRef.getResult();

      if (canvas) {
        const x = gallery
          ? this.getResizedCanvas(canvas, 400, 300)
          : this.getResizedCanvas(canvas, 300, 300);
        x.toBlob((blob) => {
          this.$store.state.loading = true;

          const imgName =
            this.galleryImg !== null ? `${this.galleryImg}.png` : 'profilepic.png';
          console.log(this.galleryImg, imgName);
          const storageRef = firebase
            .storage()
            .ref(`images/${this.$store.state.user_data.id}/${imgName}`);

          storageRef
            .put(blob)
            .then((e) => {
              this.sucess_upload = e;
              return e.ref.getDownloadURL();
            })
            .then((downloadURL) => {
              if (this.galleryImg !== null) {
                if (!this.$store.state.user_data.galleryImages) {
                  this.$store.state.user_data.galleryImages = [];
                }
                this.$store.state.user_data.galleryImages[this.galleryImg] =
                  downloadURL;
              } else {
                this.$store.state.user_data.thumbnail = downloadURL;
                this.$store.state.user_data.big_thumbnail = downloadURL;
                this.$store.state.user_data.profile_pic = downloadURL;
              }

              this.$store.commit({
                type: 'openSnackbar',
                text: 'Bild hochgeladen',
              });
              this.galleryImg = null;
              this.$store.state.loading = false;
              this.showCroppie = false;
              this.$emit('upload');
            })
            .catch((e) => {
              this.galleryImg = null;
              this.showCroppie = false;
              this.$store.state.loading = false;
            });
        }, 'image/png');
      }
    },

    async cropRegistrationAvatar() {
      const { canvas } = this.$refs.croppieDialog.$refs.croppieRef.getResult();
      const uuid = uuidv4();

      if (canvas) {
        const x = this.getResizedCanvas(canvas, 300, 300);
        x.toBlob((blob) => {
          this.$store.state.loading = true;
          const imgName = `profilepic_${uuid}.png`;
          const storageRef = firebase.storage().ref(`images/profilepics/${imgName}`);

          storageRef
            .put(blob)
            .then((e) => e.ref.getDownloadURL())
            .then((downloadURL) => {
              this.user_data.thumbnail = downloadURL.replace(
                /profilepic/g,
                'profilepic_70x70',
              );
              this.user_data.big_thumbnail = downloadURL.replace(
                /profilepic/g,
                'profilepic',
              );
              this.user_data.profile_pic = downloadURL;
              this.$store.state.loading = false;
              this.showCroppie = false;
              this.selectedStep++;
              window.scrollTo(0, 0);
            })
            .catch((err) => {
              this.$store.state.snackText =
                'Ups etwas ist schief gelaufen versuche es nochmal.';
              this.$store.state.snackbar = true;
              this.$store.state.loading = false;
            });
        });
      }
    },

    async cropRegistrationAvatarTeam() {
      const { canvas } = this.$refs.croppieDialog.$refs.croppieRef.getResult();

      if (canvas) {
        const x = this.getResizedCanvas(canvas, 300, 300);
        x.toBlob((blob) => {
          this.$store.state.loading = true;
          const imgName = 'profilepic.png';
          const storageRef = firebase
            .storage()
            .ref(`images/${this.$store.state.user_uid}/${imgName}`);

          storageRef
            .put(blob)
            .then((e) => e.ref.getDownloadURL())
            .then((downloadURL) => {
              this.user_data.thumbnail = downloadURL.replace(
                /profilepic/g,
                'profilepic_70x70',
              );
              this.user_data.big_thumbnail = downloadURL.replace(
                /profilepic/g,
                'profilepic',
              );
              this.user_data.profile_pic = downloadURL;
              this.$store.state.loading = false;
              this.showCroppie = false;
              this.selectedStep++;
              window.scrollTo(0, 0);
            })
            .catch((err) => {
              this.$store.state.snackText =
                'Ups etwas ist schief gelaufen versuche es nochmal.';
              this.$store.state.snackbar = true;
              this.$store.state.loading = false;
            });
        });
      }
    },

    getResizedCanvas(canvas, newWidth, newHeight) {
      const tmpCanvas = document.createElement('canvas');
      tmpCanvas.width = newWidth;
      tmpCanvas.height = newHeight;

      const ctx = tmpCanvas.getContext('2d');
      ctx.drawImage(
        canvas,
        0,
        0,
        canvas.width,
        canvas.height,
        0,
        0,
        newWidth,
        newHeight,
      );

      return tmpCanvas;
    },
  },
};
